import React from 'react';
import InfoPage from '../components/InfoPage';

export default function SweepstakesRules() {
  return <InfoPage title="KACHNG Sweepstakes Official Rules" updated updatedDate="2026-04-22" updatedLabel="April 22, 2026" contents={[["promotion-description", "Promotion Description"], ["eligibility", "Eligibility"], ["promotion-period", "Promotion Period"], ["how-to-enter", "How to Enter"], ["winner-selection", "Winner Selection"], ["winner-notification", "Winner Notification"], ["prizes", "Prizes"], ["general-conditions", "General Conditions"], ["disputes-and-governing-law", "Disputes and Governing Law"], ["limitations-of-liability", "Limitations of Liability"], ["privacy", "Privacy"], ["publicity-rights", "Publicity Rights"], ["winners-list", "Winners List"], ["sponsor", "Sponsor"], ["modification-of-rules", "Modification of Rules"]]}>
          {/* NO PURCHASE NECESSARY */}
          <section className="legal-section">
            <div className="no-purchase-banner">
              <strong>NO PURCHASE NECESSARY TO ENTER OR WIN. A PURCHASE WILL NOT INCREASE YOUR CHANCES OF WINNING. VOID WHERE PROHIBITED.</strong>
            </div>
          </section>

          {/* 1. PROMOTION DESCRIPTION */}
          <section className="legal-section">
            <h2 id="promotion-description">1. Promotion Description</h2>
            <p>
              The KACHNG Sweepstakes (the "Promotion") is a sweepstakes conducted by Gibbas Inc. ("KACHNG," "we," "us," or "our"). 
              By participating, entrants agree to be bound by these Official Rules and the decisions of KACHNG, which are final 
              and binding in all respects.
            </p>
          </section>

          {/* 2. ELIGIBILITY */}
          <section className="legal-section">
            <h2 id="eligibility">2. Eligibility</h2>
            <p>
              The Promotion is open to legal residents of the fifty (50) United States, the District of Columbia, and Canada 
              (excluding Quebec) who are eighteen (18) years of age or older at the time of entry.
            </p>
            <p>Entrants must meet the age requirement at the time of entry. Entries submitted by anyone under 18 are void. If an entrant who was under 18 at entry is selected as a potential winner, they will be disqualified and forfeit the prize. An alternate eligible winner may be selected under these Official Rules. Turning 18 after entry does not make an ineligible entry valid.</p>
            <p><strong>Employees, officers, directors, and representatives of KACHNG</strong> are not eligible to participate.</p>
            <p>The Promotion is subject to all applicable federal, state, provincial, and local laws and regulations and is void where prohibited.</p>
          </section>

          {/* 3. PROMOTION PERIOD */}
          <section className="legal-section">
            <h2 id="promotion-period">3. Promotion Period</h2>
            <p>
              Each sweepstakes will have specific start and end dates as announced on the KACHNG website and mobile application. 
              The April 2026 promotion has ended. Its details are retained below for reference:
            </p>
            <ul>
              <li><strong>Promotion Name:</strong> Win $100 Cash</li>
              <li><strong>Start Date:</strong> Wednesday April 22, 2026 at 05:00 AM PST</li>
              <li><strong>End Date:</strong> Friday 24, 2026 at 04:00 PM PST</li>
              <li><strong>Winner Drawing:</strong> Within 5 days following the End Date</li>
            </ul>
            <p>
              Entries received before or after the Promotion Period will not be eligible. KACHNG's computer is the official 
              time-keeping device for this Promotion.
            </p>
          </section>

          {/* 4. HOW TO ENTER */}
          <section className="legal-section">
            <h2 id="how-to-enter">4. How to Enter</h2>
            
            <h3>Method 1: Automatic Entry via Receipt Processing</h3>
            <p>
              During the Promotion Period, each digital receipt you process through the KACHNG mobile application or email 
              forwarding system will automatically generate one (1) entry into the sweepstakes. To process receipts:
            </p>
            <ol>
              <li>Download the KACHNG mobile application or sign up at kachng.co</li>
              <li>Create your KACHNG account and obtain your unique KACHNG email address</li>
              <li>Forward digital receipts to your KACHNG email address or allow merchants to send receipts directly</li>
              <li>Each successfully processed receipt = one (1) automatic entry</li>
            </ol>
            
            <h3>Method 2: Alternative Method of Entry (No Receipt Required)</h3>
            <p>
              During the Promotion Period, a free entry form was available on the Rewards page. That promotion has ended and the form is no longer available. The alternative email entry method during the Promotion Period was to email <a href="mailto:info@kachngco.com"><strong>info@kachngco.com</strong></a> with the subject line "Sweepstakes Entry" and include your
              full name, email address, date of birth, and ZIP code in the body.
            </p>
            
            <h3>Entry Limits</h3>
            <ul>
              <li><strong>Receipt-Based Entries:</strong> Unlimited. Each valid receipt processed = one entry.</li>
              <li><strong>Free Entry Form/Email Entries:</strong> One (1) per day during Promotion Period.</li>
            </ul>
            
            <p>
              All entries must be received during the Promotion Period to be eligible. Use of any automated system to enter is 
              prohibited and will result in disqualification.
            </p>
          </section>

          {/* 5. WINNER SELECTION */}
          <section className="legal-section">
            <h2 id="winner-selection">5. Winner Selection</h2>
            <p>
              Winner(s) will be selected in a random drawing from all eligible entries received during the Promotion Period. 
              The drawing will be conducted within seven (7) days following the End Date by KACHNG or its designated representative, 
              whose decisions are final and binding.
            </p>
            <p>
              Odds of winning depend on the number of eligible entries received. As of the last update, approximately 191 entries 
              have been received.
            </p>
          </section>

          {/* 6. WINNER NOTIFICATION */}
          <section className="legal-section">
            <h2 id="winner-notification">6. Winner Notification</h2>
            <p>
              Winner(s) will be notified by email at the email address associated with their KACHNG account within seven (7) days 
              of the drawing. Winner(s) must respond within seventy-two (72) hours of notification to claim their prize. Failure 
              to respond within this timeframe may result in forfeiture of the prize and selection of an alternate winner.
            </p>
            <p>
              Winners will be publicly announced (first name and last initial only) on KACHNG's X (formerly Twitter) account 
              (<a href="https://x.com/kachng" target="_blank" rel="noopener noreferrer">@kachng</a>) and website. 
              Winner announcements are typically made on Sundays.
            </p>
            <p>
              Winner may be required to complete and return an Affidavit of Eligibility, Liability Release, and (where legal) 
              a Publicity Release within seven (7) days of notification. Non-compliance within this time period may result in 
              disqualification and selection of an alternate winner.
            </p>
          </section>

          {/* 7. PRIZES */}
          <section className="legal-section">
            <h2 id="prizes">7. Prizes</h2>
            <p><strong>Current Promotion Prize:</strong></p>
            <ul>
              <li><strong>Prize:</strong> $100.00 USD cash, deposited directly to winner's verified bank account or PayPal account</li>
              <li><strong>Approximate Retail Value (ARV):</strong> $100.00 USD</li>
              <li><strong>Number of Prizes:</strong> One (1)</li>
            </ul>
            
            <h3>Prize Conditions:</h3>
            <ul>
              <li>Prize will be awarded only if potential winner fully complies with these Official Rules.</li>
              <li>No substitution, transfer, or cash equivalent of prize permitted, except by KACHNG who reserves the right to 
              substitute a prize of equal or greater value in the event the advertised prize is unavailable.</li>
              <li>Winner is solely responsible for all applicable federal, state, provincial, and local taxes on the value of 
              the prize, if any.</li>
              <li>If prize value exceeds $600 USD, winner will receive an IRS Form 1099 and must provide valid taxpayer 
              identification information.</li>
              <li>Prize will be delivered within thirty (30) days of winner verification and completion of all required documentation.</li>
            </ul>
          </section>

          {/* 8. GENERAL CONDITIONS */}
          <section className="legal-section">
            <h2 id="general-conditions">8. General Conditions</h2>
            <p>
              By entering, participants agree to release and hold harmless KACHNG, Gibbas Inc., and their respective parents, 
              subsidiaries, affiliates, directors, officers, employees, and agents from any and all liability for any injuries, 
              losses, or damages of any kind caused by participation in this Promotion or resulting from acceptance, possession, 
              or use of any prize.
            </p>
            <p>
              KACHNG reserves the right, in its sole discretion, to disqualify any individual found to be:
            </p>
            <ul>
              <li>Tampering with the entry process or the operation of the Promotion;</li>
              <li>Acting in violation of these Official Rules;</li>
              <li>Acting in an unsportsmanlike or disruptive manner; or</li>
              <li>Engaging in fraudulent or deceptive practices.</li>
            </ul>
            <p>
              In the event of a dispute regarding entries received from multiple users having the same email account, the 
              authorized subscriber of the email account at the time of entry will be deemed to be the entrant. "Authorized 
              account holder" is defined as the natural person who is assigned to an email address by an Internet access provider, 
              online service provider, or other organization responsible for assigning email addresses.
            </p>
          </section>

          {/* 9. DISPUTES */}
          <section className="legal-section">
            <h2 id="disputes-and-governing-law">9. Disputes and Governing Law</h2>
            <p>
              Except where prohibited, by participating, entrants agree that any and all disputes, claims, and causes of action 
              arising out of or connected with this Promotion or any prize awarded shall be resolved individually, without resort 
              to any form of class action, and exclusively in the appropriate court located in the jurisdiction where KACHNG 
              conducts business.
            </p>
            <p>
              These Official Rules shall be governed by and construed in accordance with the laws of the United States, without 
              regard to conflicts of law principles.
            </p>
          </section>

          {/* 10. LIMITATIONS OF LIABILITY */}
          <section className="legal-section">
            <h2 id="limitations-of-liability">10. Limitations of Liability</h2>
            <p>
              KACHNG is not responsible for:
            </p>
            <ul>
              <li>Late, lost, delayed, damaged, incomplete, illegible, or misdirected entries, responses, or other correspondence;</li>
              <li>Telephone, electronic, hardware, software, network, Internet, or other computer- or communications-related 
              malfunctions or failures;</li>
              <li>Any Promotion disruptions, injuries, losses, or damages caused by events beyond the control of KACHNG;</li>
              <li>Any printing, typographical, administrative, or technological errors in any materials associated with the Promotion.</li>
            </ul>
            <p>
              If, for any reason, the Promotion is not capable of running as planned due to infection by computer virus, bugs, 
              tampering, unauthorized intervention, fraud, technical failures, or any other causes beyond the control of KACHNG 
              that corrupt or affect the administration, security, fairness, integrity, or proper conduct of the Promotion, KACHNG 
              reserves the right, in its sole discretion, to disqualify any individual implicated in such action and/or to cancel, 
              terminate, modify, or suspend the Promotion.
            </p>
          </section>

          {/* 11. PRIVACY */}
          <section className="legal-section">
            <h2 id="privacy">11. Privacy</h2>
            <p>
              Information collected from entrants is subject to KACHNG's Privacy Policy, available at 
              <a href="/privacy"> kachng.co/privacy</a>. By entering, you consent to KACHNG's collection
              and use of your personal information as described in the Privacy Policy and these Official Rules.
            </p>
            <p>
              Entry information may be used for winner notification, prize fulfillment, and announcement purposes. Winners consent 
              to the use of their name and likeness for promotional purposes without additional compensation, except where prohibited by law.
            </p>
          </section>

          {/* 12. PUBLICITY RIGHTS */}
          <section className="legal-section">
            <h2 id="publicity-rights">12. Publicity Rights</h2>
            <p>
              Except where prohibited, participation in the Promotion constitutes winner's consent to KACHNG's use of winner's 
              name, likeness, voice, opinions, biographical information, hometown, and state for promotional purposes in any media 
              without further payment or consideration.
            </p>
          </section>

          {/* 13. WINNERS LIST */}
          <section className="legal-section">
            <h2 id="winners-list">13. Winners List</h2>
            <p>
              For the name of the winner(s), send a KACHNG Sweepstakes Winner List Request by email to <a href="mailto:info@kachngco.com">info@kachngco.com</a> with "Winner List Request"
              in the subject line. Requests must be received within thirty (30) days following the drawing date.
            </p>
          </section>

          {/* 14. SPONSOR */}
          <section className="legal-section">
            <h2 id="sponsor">14. Sponsor</h2>
            <p>
              This Promotion is sponsored by Gibbas Inc., doing business as KACHNG. For questions regarding the Promotion, 
              contact us at <a href="mailto:info@kachngco.com"><strong>info@kachngco.com</strong></a>.
            </p>
          </section>

          {/* 15. MODIFICATION */}
          <section className="legal-section">
            <h2 id="modification-of-rules">15. Modification of Rules</h2>
            <p>
              KACHNG reserves the right to modify these Official Rules at any time. Any changes will be posted on this page 
              with an updated "Last Updated" date. Continued participation in the Promotion following any such modifications 
              constitutes acceptance of those changes.
            </p>
          </section>

          {/* FOOTER STATEMENT */}
          <section className="legal-section rules-footer">
            <p className="rules-closing">
              By participating in this Promotion, entrants acknowledge that they have read, understood, and agree to be bound 
              by these Official Rules and the decisions of KACHNG, which shall be final in all respects.
            </p>
            <p className="rules-trademark">
              KACHNG is a trademark of Gibbas Inc. All other trademarks are the property of their respective owners.
            </p>
          </section>

  </InfoPage>;
}
